import CookieConsent from "react-cookie-consent";

export default function CookieBanner() {
    return (
        <CookieConsent
            location="bottom"
            buttonText="I understand"
            cookieName="belskyCookieConsent"
            style={{
              background: "#2B373B",
              color: "#ffffff",
              padding: "10px 20px",
              zIndex: 99994
            }}
            buttonStyle={{
              color: "#000000",
              fontSize: "16px",
              background: "#94a3b8",
              borderRadius: "20px",
              padding: "10px 20px",
            //   width: "auto"
            }}
            buttonWrapperClasses="cookie-banner-button-container"
            buttonClasses="cookie-banner-button"
            expires={365}
        >
            This website uses cookies to enhance the user experience.
            By continuing to browse, you agree to our use of cookies.
        </CookieConsent>
    )
}